// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"e1819091","513":"71ecb394","787":"375e36db"}[chunkId] + ".chunk.js";
};